







































import { Component, Prop, Vue } from 'vue-property-decorator';
import AlarmEquipDialogList from '@/views/dataView/ziYangDataViewBlack/rcDialog/alarmEquipDialogList.vue';
import { zyScreenServer } from '@/api/installServer';
@Component({
  components: { AlarmEquipDialogList },
})
export default class Box1 extends Vue {
  private numForm: any = {
    alarmDeviceNum: 0,
    cameraDeviceNum: 0,
    companyNum: 0,
    monitorDeviceNum: 0,
  };
  mounted() {
    this.getData({});
  }
  getData(opts: any) {
    zyScreenServer
      .getCompanyAndDeviceData({
        companyId: opts.deptId,
      })
      .then((res: any) => {
        if (res.code === '200' && res.data) {
          this.numForm = res.data;
        }
      });
  }
  showDialog(type: any) {
    const refName = 'AlarmEquipDialogListRef';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog();
  }
}
